import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, Ref } from "vue";
import OculaiVideoPlayer from "@/components/other/OculaiVideoPlayer.vue";
import { OculaiVideoPlayerProps } from "@/types/VideoPlayer";
import { useVideoPlayerDimensions } from "@/views/dashboard/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetVideoPlayer',
  props: {
    getContainerRef: { type: Function },
    src: {},
    loading: { type: Boolean },
    noSrcMessage: {},
    hls: { type: Boolean },
    autoPlay: { type: Boolean },
    addRightSpaceToControlBar: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const playerProps = computed(() => {
  const { getContainerRef, ...rest } = props;
  return rest;
});

const playerDimensions = useVideoPlayerDimensions(props.getContainerRef());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ height: `${_unref(playerDimensions).height}px` }),
    class: "bg-oaiGray-900 flex flex-col items-center"
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({
        width: `${_unref(playerDimensions).width}px`,
      }),
      class: "overflow-hidden"
    }, [
      _createVNode(OculaiVideoPlayer, _normalizeProps(_guardReactiveProps(playerProps.value)), null, 16)
    ], 4)
  ], 4))
}
}

})